module.exports = __webpack_public_path__ + "static/media/gloowheader.583e0f03.png";